import { AAKeywordInput } from '../../lib/types/models/aa-keywords/aa-keyword-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateAAKeyword(data: UpdateInput<AAKeywordInput>) {
  const { id, ...rest } = data
  return restApiClient.url(constructApiUrl(API.aAKeyWords.update.url, { id })).patch(rest)
}
